import type { AppTask } from "./types";

/**
 * Статический список задач до подключения OMP API.
 *
 * `FolderName` — путь папки в OMP (без префикса «Задачи»; контекст задач задаёт экран `/tasks`).
 * Задачи «Складской учёт» — заглушки по дорожной карте (README).
 */
export const STATIC_TASKS: AppTask[] = [
    {
        Code: 2001,
        Name: "Акты инвентаризации",
        FolderName: "Учёт в производстве",
    },
    {
        Code: 2002,
        Name: "Внутризаводские накладные (Приход)",
        FolderName: "Учёт в производстве",
    },
    {
        Code: 2003,
        Name: "Внутризаводские накладные (Расход)",
        FolderName: "Учёт в производстве",
    },
    {
        Code: 2004,
        Name: "Лимитные карты (Приход)",
        FolderName: "Учёт в производстве",
    },
    {
        Code: 2005,
        Name: "Цеховая номенклатура",
        FolderName: "Учёт в производстве",
    },
    {
        Code: 3001,
        Name: "Размещение ТМЦ",
        FolderName: "Складской учёт",
    },
    {
        Code: 3002,
        Name: "Комплектация «КАНБАН»",
        FolderName: "Складской учёт",
    },
    {
        Code: 3003,
        Name: "Комплектация по КВ",
        FolderName: "Складской учёт",
    },
    {
        Code: 3004,
        Name: "Приёмка на СГП",
        FolderName: "Складской учёт",
    },
    {
        Code: 3005,
        Name: "Отгрузка СГП",
        FolderName: "Складской учёт",
    },
    {
        Code: 3006,
        Name: "Полная инвентаризация склада",
        FolderName: "Складской учёт",
    },
    {
        Code: 3007,
        Name: "Частичная инвентаризация склада",
        FolderName: "Складской учёт",
    },
];
